import { stringify as stringifyQs } from "qs";

import {
  ActiveTab,
  BulkAction,
  Dialog,
  Filters,
  FiltersWithMultipleValues,
  Pagination,
  SingleAction,
  TabActionDialog
} from "../../types";

// import urlJoin from "url-join";

const StoresReportSection = "/reports/omi/stores";

export const StoresReportListPath = StoresReportSection;

export enum StoresListUrlFiltersEnum {
  query = "query"
}

export enum StoresListUrlFiltersWithMultipleValues {
  mall = "mall",
  brand = "brand",
  storeStatus = "storeStatus"
}
export type StoresListUrlDialog =
  | "add"
  | "view-store"
  | "assign"
  | "download"
  | TabActionDialog;
export type StoresListUrlFilters = Filters<StoresListUrlFiltersEnum> &
  FiltersWithMultipleValues<StoresListUrlFiltersWithMultipleValues>;

export type StoresListUrlQueryParams = ActiveTab &
  StoresListUrlFilters &
  BulkAction &
  Dialog<StoresListUrlDialog> &
  Pagination &
  SingleAction;

export const StoresListUrl = (params?: StoresListUrlQueryParams) =>
  StoresReportListPath + "?" + stringifyQs(params);
